export const LEAVE_APPROVER_KEYS = [
  'boss',
  'leave_approver_1',
  'leave_approver_2',
  'leave_approver_3',
]

export const LEAVE_APPROVER_LABELS = {
  boss: 'หัวหน้าหน่วยงาน',
  leave_approver_1: 'ผู้อนุมัติคนที่ 1',
  leave_approver_2: 'ผู้อนุมัติคนที่ 2',
  leave_approver_3: 'ผู้อนุมัติคนที่ 3',
}
